"use strict";
const contactTeaserElements = Array.from(document.querySelectorAll('.tx-ttaddress-item'));
if (contactTeaserElements) {
    contactTeaserElements.forEach((contactTeaser) => {
        (contactTeaser.parentElement.classList.contains('frame-37')) ? contactTeaser.parentElement.classList.add('wrapper-tt-address-item') : '';
    });
    const interactiveContactTeaserWrapper = Array.from(document.querySelectorAll('.wrapper-tt-address-item'));
    interactiveContactTeaserWrapper.forEach((interactiveTeaser) => {
        const wrapper = interactiveTeaser;
        const teaserContent = interactiveTeaser.children[1];
        teaserContent.style.visibility = 'hidden';
        wrapper.style.height = '8rem';
        interactiveTeaser.addEventListener("mouseenter", (event) => {
            wrapper.style.height = 'auto';
            (teaserContent.style.visibility === 'hidden') ? teaserContent.style.visibility = 'visible' : teaserContent.style.visibility = 'hidden';
        });
        interactiveTeaser.addEventListener("mouseleave", (event) => {
            wrapper.style.height = '8rem';
            (teaserContent.style.visibility === 'visible') ? teaserContent.style.visibility = 'hidden' : teaserContent.style.visibility = 'visible';
        });
    });
}
